import { Validator } from '@vista-digital/validator';
import { fieldDisplayTextValidatorSchema } from '../../types/field-display-text';
export const dropdownFieldDisplayTextValidatorSchema = {
    label: Validator.optional(fieldDisplayTextValidatorSchema.label),
    requiredMessage: Validator.optional(fieldDisplayTextValidatorSchema.requiredMessage),
    placeholder: fieldDisplayTextValidatorSchema.placeholder,
    noSearchResultsFoundMessage: Validator.optional(Validator.nonEmptyString)
};
export const dropdownFieldDisplayTextValidator = Validator.object(dropdownFieldDisplayTextValidatorSchema);
//# sourceMappingURL=display-text.js.map